import React, { useState } from 'react';

import BasicLayout from 'components/BasicLayout';
import EmptyList from 'components/EmptyList';
import Loader from 'components/Loader';
import TripCard, { ShimmerTripCard } from 'components/TripCard';
import { HelpLink } from 'components/TripCard/styles';
import TripListContainer from 'containers/TripList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelForCustomerSupport } from 'models/customerSupport';

import { mapCustomerSupportTravel } from '../../utils/mapper';
import { SectionTitle, AllTripsWrapper } from './styles';

type TripListProps = {
  travels: TravelForCustomerSupport[];
  totalCount: number;
};

const TripList = ({ travels, totalCount }: TripListProps) => {
  const { t } = useStoreTranslation();
  const [detailsOpen, setDetailsOpen] = useState(-1);
  return travels.length > 0 ? (
    <>
      <SectionTitle>{t('customerSupport.tripSupportTitle')}</SectionTitle>
      {[...Array(totalCount).keys()].map((index) => {
        const travel = travels[index];

        return travel ? (
          <TripCard
            travel={mapCustomerSupportTravel(travel)}
            onToggle={(status) => {
              setDetailsOpen(status ? index : -1);
            }}
            detailsOpen={detailsOpen === index}
          >
            <HelpLink to={`/customerSupport/trip/${travel.travelId}`}>Help</HelpLink>
          </TripCard>
        ) : (
          <ShimmerTripCard />
        );
      })}
    </>
  ) : (
    <EmptyList
      transparent
      title={t('customerSupport.allTrips.tripList.empty.title')}
      description={t('customerSupport.allTrips.tripList.empty.description')}
      paddingMessage={48}
      image="/images/receipt-list-43-colored-48.svg"
    />
  );
};

const AllTrips = () => {
  const { t } = useStoreTranslation();
  return (
    <BasicLayout backPath="/customerSupport" title={t('customerSupport.title')}>
      <AllTripsWrapper>
        <TripListContainer
          render={(loading, { travels, totalCount }) =>
            loading ? <Loader fullScreen /> : <TripList travels={travels} totalCount={totalCount} />
          }
        />
      </AllTripsWrapper>
    </BasicLayout>
  );
};

export default AllTrips;
